import React from "react";

const MyDataSection: React.FC = () => {
  return (
    <section aria-labelledby="my-data-section-heading" className="py-8">
      <div className="container mx-auto px-4">
        <div className="mx-auto max-w-3xl rounded-2xl border border-primary-100 bg-white p-8 text-center shadow-sm">
          <h2
            id="my-data-section-heading"
            className="text-lg font-bold text-primary-700"
          >
            入力したデータはブラウザの中だけに保存されます
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-primary-700">
            各ツールで入力した体重や年齢は、次回も続きから使えるようにこのブラウザ内にだけ自動保存しています。保存されている内容の確認や削除は「マイデータ」からできます。
          </p>
          <a
            href="/me/"
            className="mt-5 inline-block rounded-lg border border-primary-200 px-4 py-2 text-sm font-medium text-primary-700 transition-colors duration-200 hover:bg-primary-50"
          >
            あなたのデータを見る →
          </a>
        </div>
      </div>
    </section>
  );
};

export default MyDataSection;
